import { ModelBase } from "../abstract/model-base.model";
import { Client } from "../client/client.model";
import { AssistantClient } from "./assistant-client.model";

/**
 * Demande d'autorisation d'un assistant IA (#1312), telle que la page
 * `/oauth/authorize` la reçoit : les paramètres posés par l'assistant dans l'URL
 * (`redirectUri`, `codeChallenge`, `codeChallengeMethod`, `state`), complétés par la
 * réponse du serveur — l'assistant qui demande, et les dossiers sur lesquels
 * l'utilisateur peut l'autoriser.
 */
export class AssistantAuthorizationRequest extends ModelBase {

    static override CLASS_NAME: string = 'AssistantAuthorizationRequest';

    private _assistant!: AssistantClient;
    private _clients!: Client[];
    private _codeChallenge!: string;
    private _codeChallengeMethod!: string;
    private _redirectUri!: string;
    private _state!: string;

    public get assistant(): AssistantClient {
        return this._assistant;
    }

    public set assistant(value: any) {
        this._setValue('_assistant', value, 'AssistantClient');
    }

    public get clients(): Client[] {
        return this._clients;
    }

    public set clients(value: any) {
        this._setValue('_clients', value, 'Client');
    }

    public get codeChallenge(): string {
        return this._codeChallenge;
    }

    public set codeChallenge(value: any) {
        this._setValue('_codeChallenge', value, 'string');
    }

    public get codeChallengeMethod(): string {
        return this._codeChallengeMethod;
    }

    public set codeChallengeMethod(value: any) {
        this._setValue('_codeChallengeMethod', value, 'string');
    }

    public get redirectUri(): string {
        return this._redirectUri;
    }

    public set redirectUri(value: any) {
        this._setValue('_redirectUri', value, 'string');
    }

    public get state(): string {
        return this._state;
    }

    public set state(value: any) {
        this._setValue('_state', value, 'string');
    }

}
